import { motion } from "framer-motion";
import { MapPin, Navigation, Clock } from "lucide-react";

export const VisitUs = () => (
  <section id="visit" data-testid="visit-section" className="bg-white py-28 lg:py-40">
    <div className="max-w-7xl mx-auto px-6 lg:px-12">
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-stretch">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-5 flex flex-col justify-center"
        >
          <p className="text-xs font-bold tracking-[0.3em] uppercase text-electric mb-6">Find Us</p>
          <h2 className="font-display font-extrabold text-4xl sm:text-5xl tracking-tighter text-ink leading-[0.95] mb-8">
            In the heart of<br />Plumstead.
          </h2>
          <p className="text-neutral-600 text-base lg:text-lg leading-relaxed mb-10 max-w-md">
            Our practice has its own private entrance with dedicated treatment rooms and rehabilitation
            space — serving the Southern Suburbs of Cape Town.
          </p>
          <ul className="space-y-5 mb-10">
            <li className="flex items-start gap-4" data-testid="visit-address">
              <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-electric/10 text-electric shrink-0">
                <MapPin size={18} />
              </span>
              <span className="text-ink text-base pt-2">58 Dick Burton Street, Plumstead,<br />Cape Town, Western Cape</span>
            </li>
            <li className="flex items-start gap-4" data-testid="visit-hours">
              <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-electric/10 text-electric shrink-0">
                <Clock size={18} />
              </span>
              <span className="text-ink text-base pt-2">Monday – Friday, 08:00 – 17:00</span>
            </li>
          </ul>
          <a
            href="https://www.google.com/maps/dir/?api=1&destination=58+Dick+Burton+Street,+Plumstead,+Cape+Town"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="get-directions-button"
            className="group inline-flex w-fit items-center gap-3 rounded-full bg-navy text-white text-xs font-bold tracking-[0.15em] uppercase px-8 py-4 hover:bg-electric transition-colors duration-300"
          >
            Get Directions
            <Navigation size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
          </a>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ delay: 0.15, duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-7"
        >
          <div className="rounded-lg overflow-hidden border border-black/10 shadow-[0_24px_64px_rgba(0,26,77,0.12)] h-[380px] lg:h-full min-h-[380px]" data-testid="map-embed">
            <iframe
              title="FivePoint Physiotherapy — 58 Dick Burton Street, Plumstead, Cape Town"
              src="https://www.google.com/maps?q=58+Dick+Burton+Street,+Plumstead,+Cape+Town&output=embed"
              className="w-full h-full border-0"
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </motion.div>
      </div>
    </div>
  </section>
);
